import React, { useState, useEffect } from 'react';
import { Sidebar } from 'primereact/sidebar';
import CustomSelect from '../../components/common/CustomSelect';
import { propertySaleTypes, PropertyTypeList } from '../../Enum';
import LocationService from '../../components/Services/LocationService';
import { FiCalendar } from 'react-icons/fi';
import { propertyTypes } from '../Enum/PropertyEnum';
import UserService from '../../GlobalSetupComponents/Services/UserService';
import { backendProcurementHeadRoles, roleIdProcurement } from '../../GlobalSetupComponents/Enum/RoleEnum';

const RoughFilter = ({ isOpen, onClose, onApplyFilters, currentFilters = {} }) => {
  // Filter states
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedPropertyType, setSelectedPropertyType] = useState(null);
  const [selectedPropertySource, setSelectedPropertySource] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [locationData, setLocationData] = useState([]);
  const [propertySourceOptions , setPropertySourceOptions] = useState([])

  // Sync with current filters from parent
  useEffect(() => {
    setSelectedLocation(currentFilters.location || null);
    setSelectedPropertyType(currentFilters.propertyType || null);
    setSelectedPropertySource(currentFilters.propertySource || null);
    setStartDate(currentFilters.startDate || '');
    setEndDate(currentFilters.endDate || '');
  }, [currentFilters]);




  // Fetch location data on component mount
  useEffect(() => {
    const fetchLocationData = async () => {
      try {
        const response = await LocationService.fetchLocation();
        const rawData = response.data || {};
        const formattedData = Array.isArray(rawData)
          ? rawData.map((item) => ({
              value: item.id,
              label: item.label || item.name || "",
            }))
          : Object.entries(rawData).map(([label, id]) => ({
              value: id,
              label: label,
            }));
        setLocationData(formattedData);
      } catch (error) {
        console.error("Error fetching location data:", error);
      }
    };

    if (isOpen) {
      fetchLocationData();
    }
  }, [isOpen]);

  const FetchPropertySourceOptions =  async() => {

   try{
            const body = { roleIds: roleIdProcurement };
        const response = await UserService.getUserRoleBasedNames(body);
        const data = response.data?.users || [];
        setPropertySourceOptions(data)
   }catch(error){
        console.error("Error fetching property source options:", error);
   }
  }

  useEffect(() => {
    FetchPropertySourceOptions();
  }, []);

  // Handle filter application
  const handleApplyFilters = () => {
    const filters = {
      location: selectedLocation,
      propertyType: selectedPropertyType,
      propertySource: selectedPropertySource,
      startDate: startDate,
      endDate: endDate,
    };

    console.log("Applied Filters:", filters);
    if (onApplyFilters) {
      onApplyFilters(filters);
    }
    onClose();
  };

  // Handle filter reset
  const handleClearFilters = () => {
    setSelectedLocation(null);
    setSelectedPropertyType(null);
    setSelectedPropertySource(null);
    setStartDate('');
    setEndDate('');
    
    const emptyFilters = {
      location: null,
      propertyType: null,
      propertySource: null,
      startDate: '',
      endDate: '',
    };

    if (onApplyFilters) {
      onApplyFilters(emptyFilters);
    }
    onClose();
  };

  // Get today's date for max date validation
  const today = new Date().toISOString().split('T')[0];

  return (
    <Sidebar
      header={
        <div className="flex items-center justify-between w-full">
          <span className="font-semibold text-lg text-customGreen">
            <h3>Property Filters</h3>
          </span>
        </div>
      }
      visible={isOpen}
      onHide={onClose}
      style={{ width: "400px" }}
      position="right"
      className="p-sidebar-md"
    >
      <div className="flex flex-col h-full justify-between gap-6 py-4">
        <div className="flex flex-col gap-4">
          <label className="text-xs text-gray-600">Location</label>
          {/* Location Filter */}
          <div className="space-y-2">
            <CustomSelect
              options={locationData}
              value={selectedLocation}
              onChange={setSelectedLocation}
              placeholder="Select Location"
              isClearable
              isSearchable
            />
          </div>

          {/* Property Type Filter */}
          {/* <div className="space-y-2">
            <label className="text-xs text-gray-600">Property Type</label>
            <CustomSelect
              options={propertyTypes}
              value={selectedPropertyType}
              onChange={setSelectedPropertyType}
              placeholder="Select Property Type"
              isClearable
              isSearchable
            />
          </div> */}

          {/* Property Source Filter */}
          <div className="space-y-2">
            <label className="text-xs text-gray-600">Property Sourced By</label>
            <CustomSelect
              options={propertySourceOptions}
              value={selectedPropertySource}
              onChange={setSelectedPropertySource}
              placeholder="Select Property Source"
              isClearable
              isSearchable
            />
          </div>

        </div>

        {/* Footer Buttons */}
        <div className="flex flex-col gap-3 border-t pt-4">
          <button
            onClick={handleApplyFilters}
            className="w-full py-2 px-4 bg-customGreen text-white rounded-md font-medium hover:bg-green-600 transition-colors focus:outline-none focus:ring-2 focus:ring-customGreen focus:ring-offset-2"
          >
            Apply Filters
          </button>
          <button
            onClick={handleClearFilters}
            className="w-full py-2 px-4 bg-gray-100 text-gray-700 rounded-md font-medium hover:bg-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2"
          >
            Clear All Filters
          </button>
        </div>
      </div>
    </Sidebar>
  );
};

export default RoughFilter;
